import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import AdminClientForm from '../../../components/ui/Admin/AdminClients/AdminClientForm'


const AdminClient = () => {
  const navigate = useNavigate()
  const params = useParams();

  const { adminClients } = useContext(SuperAdminContext)

  const [adminClient, setAdminClient] = useState(null)
  const [hasChanged, setHasChanged] = useState(false)

  const setActAdminClient = () => {
    var findAdminClient = adminClients?.find((l) => l.id.toString() == params?.id)

    if (findAdminClient) {
      //if (ecole == null) {
        setAdminClient(findAdminClient)
      //}
    } else {
      navigate("/admin/adminclient")
    }
  }

  useEffect(() => {
    if (params?.id && adminClients) {
      setActAdminClient()
    }
  }, [adminClients, adminClient, params])


  return (
    <>
      <Helmet>
        <title>Admin Clients Admins | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/adminclient"
            title="Edition d'un compte Admin Client"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={!hasChanged}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Éditer le compte
            </Button>
          </TopBar>


          {adminClient !== null && (
            <AdminClientForm
              isEdit={true}
              adminClient={adminClient}
              setHasChanged={setHasChanged}
            />
          )}

        </Box>
      </Box>
    </>
  )
};

export default AdminClient;
